import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, NgForm } from '@angular/forms';
import { CoreSidebarService } from '@core/components/core-sidebar/core-sidebar.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PersonService } from 'app/services/models/person.service';
import { UserService } from 'app/services/models/user.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-new-user-sidebar',
  templateUrl: './new-user-sidebar.component.html',
  encapsulation: ViewEncapsulation.None
})
export class NewUserSidebarComponent implements OnInit {

  public username: string;
  public password: string;
  public submitted = false;
  public passwordTextType: boolean;
  public email: string;
  persons: any[] = [];
  selectedPerson:any;
  constructor(
    private _coreSidebarService: CoreSidebarService,
    private userService: UserService,
    private toastService: ToastrService,
    private personService: PersonService
  ) {
    
  }

  async ngOnInit() {
    await this.getByIdCompanyPersons();
  }

  async getByIdCompanyPersons() {
    const data = await this.personService.getByIdCompanyPersons(1);
    this.persons = data;
    console.log(this.persons);
  }

  onPersonelChange(event) {
    console.log(event);
    this.selectedPerson = event;
  }

  toggleSidebar(name): void {
    this._coreSidebarService.getSidebarRegistry(name).toggleOpen();
  }

  async submit(form: NgForm) {
    this.submitted = true; // Form gönderimi denendi
    if (form.valid) {
      this.toggleSidebar('new-user-sidebar');
      
      const data = await this.userService.registerUser(
        form.value.username,
        form.value.userpassword,
        form.value.email,
        this.selectedPerson ?? null
      );

      if (data.status) {
        this.toastService.success(data.message);
        this.userService.sendEvent(true);
      } else {
        this.toastService.error(data.message);
      }
    }
  }

  togglePasswordTextType() {
    this.passwordTextType = !this.passwordTextType;
  }
}